import React, { useState } from "react";
import { useRegTheme } from "../theme";
import { getHeldOrders, removeHeldOrder } from "../data/heldOrders";
import { fmt } from "../uiUtils";

// "Held" — list parked sales, resume or delete one (port of the Android Held-orders list).
export default function HeldOrdersModal({ onResume, onClose, onChange }) {
  const t = useRegTheme();
  const [list, setList] = useState(() => getHeldOrders());
  // Android deleteBasket: "Are You sure you want to delete order?" before a held basket goes.
  const [confirmId, setConfirmId] = useState(null);

  const del = (id) => {
    removeHeldOrder(id);
    setConfirmId(null);
    setList(getHeldOrders());
    if (onChange) onChange();
  };

  const s = styles(t);
  return (
    <div className="qv-dlg-overlay" style={s.overlay} onClick={onClose}>
      <div className="qv-dlg-card" style={s.card} onClick={(e) => e.stopPropagation()}>
        <div style={s.head}>
          <span>Held sales ({list.length})</span>
          <button style={s.x} onClick={onClose}>✕</button>
        </div>
        <div style={s.body}>
          {list.length === 0 ? (
            <div style={s.empty}>No held sales</div>
          ) : (
            list.map((o) => (
              <div key={o.id} style={s.row}>
                <div style={{ minWidth: 0 }}>
                  <div style={s.name}>{o.name}</div>
                  <div style={s.sub}>{o.itemCount} item{o.itemCount === 1 ? "" : "s"} · {fmt(o.total)} · {fmtTime(o.at)}</div>
                </div>
                {confirmId === o.id ? (
                  <div style={{ display: "flex", gap: 8, flex: "0 0 auto", alignItems: "center", flexWrap: "wrap" }}>
                    <span style={{ fontSize: 13, fontWeight: 500 }}>Are You sure you want to delete order?</span>
                    <button style={s.del} onClick={() => del(o.id)}>Yes</button>
                    <button style={s.resume} onClick={() => setConfirmId(null)}>No</button>
                  </div>
                ) : (
                  <div style={{ display: "flex", gap: 8, flex: "0 0 auto" }}>
                    <button style={s.resume} onClick={() => onResume(o)}>Resume</button>
                    <button style={s.del} onClick={() => setConfirmId(o.id)}>Delete</button>
                  </div>
                )}
              </div>
            ))
          )}
        </div>
      </div>
    </div>
  );
}

function fmtTime(iso) {
  try {
    return new Date(iso).toLocaleString([], { month: "short", day: "numeric", hour: "2-digit", minute: "2-digit" });
  } catch {
    return "";
  }
}

const styles = (t) => ({
  overlay: { position: "fixed", inset: 0, background: "rgba(2,6,23,0.55)", display: "flex", alignItems: "center", justifyContent: "center", zIndex: 2000 },
  card: { width: "100%", maxWidth: 480, maxHeight: "88vh", background: t.card || "#0f1a2f", color: t.text || "#E5EDF7", borderRadius: 16, border: `1px solid ${t.cardBorder || "#1f2c47"}`, overflow: "hidden", display: "flex", flexDirection: "column" },
  head: { padding: "14px 18px", fontWeight: 800, fontSize: 16, borderBottom: `1px solid ${t.divider}`, display: "flex", justifyContent: "space-between", alignItems: "center", background: t.surfaceAlt || "#0f1a2f" },
  x: { border: "none", background: "none", cursor: "pointer", fontSize: 18, color: t.textMuted },
  body: { padding: 14, overflow: "auto", display: "flex", flexDirection: "column", gap: 8 },
  empty: { padding: 30, textAlign: "center", color: t.textMuted },
  row: { display: "flex", justifyContent: "space-between", alignItems: "center", gap: 10, padding: "10px 12px", border: `1px solid ${t.cardBorder}`, borderRadius: 10 },
  name: { fontWeight: 500, fontSize: 15, whiteSpace: "nowrap", overflow: "hidden", textOverflow: "ellipsis" },
  sub: { fontSize: 12, color: t.textMuted, marginTop: 2 },
  resume: { height: 38, padding: "0 16px", borderRadius: 8, border: "none", background: "#059669", color: "#fff", fontWeight: 500, cursor: "pointer" },
  del: { height: 38, padding: "0 12px", borderRadius: 8, border: `1px solid ${t.cardBorder}`, background: "transparent", color: "#EF4444", fontWeight: 500, cursor: "pointer" },
});
